// tslint:disable:max-line-length
import * as React from 'react';

export const heartFull = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <path fillRule="nonzero" d="M9.428 3.403c1.735-1.68 4.546-1.68 6.281 0a4.354 4.354 0 0 1 .012 6.177l-6.259 6.077a.7.7 0 0 1-.482.2H8.9a.686.686 0 0 1-.368-.178l-6.247-6.1a4.354 4.354 0 0 1 0-6.176c1.735-1.68 4.546-1.68 6.282 0l.413.4.448-.4z"/>
  </svg>
);

// tslint:enable:max-line-length
